import * as React from 'react';
import classnames from 'classnames';

import PopoverList from 'components/popover-list/PopoverList';

import { __t, applyTranslations } from 'utils/language';

import './create-new-profiles-entities-list-header-row.scss';

applyTranslations(require('./create-new-profiles-entities-list-header-row.i18n.json'));

const CreateNewProfilesEntitiesListHeaderRow = (): JSX.Element => {
  const artistNameClasses = classnames(
    'create-new-profiles-entities-list-header-row__cell-container',
    'create-new-profiles-entities-list-header-row__cell-container--artist-name'
  );
  const channelURLClasses = classnames(
    'create-new-profiles-entities-list-header-row__cell-container',
    'create-new-profiles-entities-list-header-row__cell-container--channel-url'
  );
  const genderClasses = classnames(
    'create-new-profiles-entities-list-header-row__cell-container',
    'create-new-profiles-entities-list-header-row__cell-container--gender'
  );
  const countryClasses = classnames(
    'create-new-profiles-entities-list-header-row__cell-container',
    'create-new-profiles-entities-list-header-row__cell-container--country'
  );
  const emailClasses = classnames(
    'create-new-profiles-entities-list-header-row__cell-container',
    'create-new-profiles-entities-list-header-row__cell-container--email'
  );
  const deleteClasses = classnames(
    'create-new-profiles-entities-list-header-row__cell-container',
    'create-new-profiles-entities-list-header-row__cell-container--delete'
  );

  return (
    <div className="create-new-profiles-entities-list-header-row">
      <div className={artistNameClasses}>
        <span className="create-new-profiles-entities-list-header-row__value">
          {__t('create_new_profiles_entities_list_header_row.artist_name')}
        </span>
        <span className="create-new-profiles-entities-list-header-row__mandatory-asterisk">
          *
        </span>
        <div className="create-new-profiles-entities-list-header-row__tooltip-container">
          <PopoverList
            list={[{
              title: __t('create_new_profiles_entities_list_header_row.artist_name_tooltip.title'),
              body: __t('create_new_profiles_entities_list_header_row.artist_name_tooltip.text')
            }]}
          />
        </div>
      </div>
      <div className={channelURLClasses}>
        <span className="create-new-profiles-entities-list-header-row__value">
          {__t('create_new_profiles_entities_list_header_row.channel_url')}
        </span>
        <span className="create-new-profiles-entities-list-header-row__mandatory-asterisk">
          *
        </span>
        <span className="create-new-profiles-entities-list-header-row__cell-description">
          {__t('create_new_profiles_entities_list_header_row.channel_url_description')}
        </span>
        <div className="create-new-profiles-entities-list-header-row__tooltip-container">
          <PopoverList
            list={[{
              title: __t('create_new_profiles_entities_list_header_row.channel_url_description_tooltip.title'),
              body: __t('create_new_profiles_entities_list_header_row.channel_url_description_tooltip.text')
            }]}
          />
        </div>
      </div>
      <div className={genderClasses}>
        <span className="create-new-profiles-entities-list-header-row__value">
          {__t('create_new_profiles_entities_list_header_row.gender')}
        </span>
      </div>
      <div className={countryClasses}>
        <span className="create-new-profiles-entities-list-header-row__value">
          {__t('create_new_profiles_entities_list_header_row.country')}
        </span>
        <div className="create-new-profiles-entities-list-header-row__tooltip-container">
          <PopoverList
            list={[{
              title: __t('create_new_profiles_entities_list_header_row.country_tooltip.title'),
              body: __t('create_new_profiles_entities_list_header_row.country_tooltip.text')
            }]}
          />
        </div>
      </div>
      <div className={emailClasses}>
        <span className="create-new-profiles-entities-list-header-row__value">
          {__t('create_new_profiles_entities_list_header_row.email')}
        </span>
      </div>
      <div className={deleteClasses} />
    </div>
  );
};

export default CreateNewProfilesEntitiesListHeaderRow;
